module.exports = __webpack_public_path__ + "img/logoblanc.3eee2a2d.png";